import { environment } from '../../environments/environment';

export type ItemDetailsVersion = 'v1' | 'v2';

export const ITEM_DETAILS_VERSION_KEY = 'itemDetailsVersion';

/**
 * Punch UI is V2-only. V1 route/component remain in the codebase because V2 extends
 * ItemDetailsComponent, but users must never open V1.
 */
export const FORCED_ITEM_DETAILS_VERSION: ItemDetailsVersion = 'v2';

export function getItemDetailsV2Divisions(): string[] {
    const raw = (environment as { itemDetailsV2Divisions?: string[] }).itemDetailsV2Divisions;
    if (Array.isArray(raw) && raw.length > 0) {
        return raw.map((d) => String(d).trim()).filter(Boolean);
    }
    return ['100'];
}

/** @deprecated V2 is mandatory for all divisions; kept for callers that still pass division. */
export function isItemDetailsV2DefaultDivision(_division: string): boolean {
    return true;
}

/** @deprecated Always V2. */
export function getDefaultItemDetailsVersionForDivision(_division: string): ItemDetailsVersion {
    return FORCED_ITEM_DETAILS_VERSION;
}

/** Always navigates to Item Details V2. `version` is ignored (kept for call-site compatibility). */
export function itemDetailsRouteCommands(_version: ItemDetailsVersion | string, id: string): string[] {
    return ['/item-v2', id];
}

/** Persist V2 so any leftover localStorage preference cannot reopen V1. */
export function persistItemDetailsVersion(_version?: ItemDetailsVersion): void {
    localStorage.setItem(ITEM_DETAILS_VERSION_KEY, FORCED_ITEM_DETAILS_VERSION);
}

/** Always V2; ignores legacy localStorage `v1`. */
export function getPersistedItemDetailsVersion(_division?: string): ItemDetailsVersion {
    persistItemDetailsVersion(FORCED_ITEM_DETAILS_VERSION);
    return FORCED_ITEM_DETAILS_VERSION;
}
